import styled from "@emotion/styled"
import {breakpoints} from "@next/ux-fabric"

export const Container = styled("div")`
    width: 100%;

    @media (min-width: ${breakpoints.values.xs}px) and (max-width: ${breakpoints.values.lg}px) {
        height: 100%;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        display: table;
    }
`
